import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectActionsMenu: {
		id: 'navigation-project-action-menu.menu-container.project-actions-menu',
		defaultMessage: 'More actions',
		description:
			'Used as the alt text for an icon button that when used shows a popup menu of more options.',
	},
	projectActionsMenuName: {
		id: 'navigation-project-action-menu.menu-container.project-actions-menu-name',
		defaultMessage: 'More actions for {name}',
		description: '{name} will be replaced with projects side menu and sub projects name.',
	},
});
